import { ReactNode, useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion'
import { Footer, Navbar } from '../components';
import { Button, Card, Typography, Carousel } from '@material-tailwind/react';
// import { Carousel } from "flowbite-react";
import APRPLogo from "../assets/images/APRPLogo.png"
import UBILogo from "../assets/images/UBILogo.png"
import UbiCover from "../assets/images/ubi_1.jpg"
import guest from "../assets/images/guest.png"
import hotel from "../assets/images/hotel.jpg"
import recpad from "../assets/images/recpad_1.jpeg"
import ubi2 from "../assets/images/ubi_m.jpg"
import ubiarea from "../assets/images/area.webp"
import rec from "../assets/Rectangle.svg"
import { Link, useNavigate } from "react-router-dom";
import MapContainer from '../components/MapContainer';

const FADE_BOTTOM = {
  initial: {
    opacity: 0,
    bottom: - 400
  },
  final: {
    opacity: 1,
    bottom: 0
  }
}

interface HomeProps {
}

export function Home({ }: HomeProps) {
  const [navbarTransparent, setNavbarTransparent] = useState(true);
  const navigate = useNavigate()

  useEffect(() => {
    const handleScroll = () => {
      // Set navbar to not transparent if the scroll position is more than 100px
      const shouldNavbarBeTransparent = window.scrollY < 100;
      setNavbarTransparent(shouldNavbarBeTransparent);
    };

    // Add event listener for scroll
    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handlePhoneNumberClick = (phoneNumber:string) => {
    navigator.clipboard.writeText(phoneNumber);
  };

  return (
    <>
      <div className="w-full relative bg-neutral-50">
        <Navbar transparent={navbarTransparent} />

        <section className="h-[450px] md:h-[570px] lg:h-[100vh] lg:min-h-[900px] relative z-10" >
          <img
            alt="ubi_cover"
            className="h-full w-full object-cover object-center absolute inset-0 -z-20"
            src={UbiCover}
          />

          <div className="absolute inset-0 bg-gradient-to-b from-primary-600/80 to-primary-600/10 -z-10" ></div>
          <div className="flex flex-col items-center justify-center lg:justify-start w-full h-full text-center text-white z-20">
            <Typography variant="h1" className="mb-2 lg:mt-72">
              RECPAD 2024
            </Typography>
            <Typography variant="h4" className="mb-2">
              OCT 25 - UNIVERSIDADE DA BEIRA INTERIOR
            </Typography>

            <Button
              variant="filled"
              size="lg"
              className=" lg:inline-block bg-ubi-500 mt-8"
              onClick={() => navigate("/registration")}
            >
              <span>Register</span>
            </Button>
          </div>

        </section>

        <motion.section className="mx-auto w-full flex container py-10 lg:-mt-80 z-30 relative mb-10 gap-10"
        >
          <div className="rounded-none w-full lg:w-[520px] min-w-[290px] lg:min-w-[520px] flex flex-col justify-center relative lg:-mt-20">
            <img src={rec} alt="whitebg" className="absolute w-full -z-10  hidden lg:block" />

            <div className="absolute -z-10 w-full " >
              {/* <svg width="588" height="648" viewBox="0 0 588 648" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_78_5)">
                  <path d="M4 0L584 77V639.5L4 577V0Z" fill="white" />
                </g>
                <defs>
                  <filter id="filter0_d_78_5" x="0" y="0" width="588" height="647.5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_78_5" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_78_5" result="shape" />
                  </filter>
                </defs>
              </svg> */}


            </div>

            <div className="py-12 px-8 w-full justify-center items-center" >
              <Typography variant="h2" color="blue-gray" className="mb-2">
                RECPAD 2024
              </Typography>
              <div>
                <Typography color="gray" className="font-normal">
                  RECPAD is the annual Portuguese Conference on Pattern Recognition, sponsored by <strong><a className="underline" href="https://aprp.pt/en/home/" target="_blank" rel="noopener noreferrer">APRP</a> </strong>
                  (Portuguese Association for Pattern Recognition).
                  It is a one-day conference with an invited keynote speaker and poster session.
                </Typography>
                <Typography color="gray" className="font-normal mt-2">
                  This 30th edition will be organized by <strong><a className="underline" href="https://www.ubi.pt/Default.aspx" target="_blank" rel="noopener noreferrer">UBI</a></strong>  (Universidade da Beira Interior)
                </Typography>
              </div>

              <div className="w-full flex items-center justify-center p-4 gap-12" >
                <img className="h-12 " src={APRPLogo} alt="APRP" />
                <img className="h-12 " src={UBILogo} alt="UBI" />
              </div>

            </div>



          </div>

          <Card className="hidden lg:block overflow-hidden rounded-xl w-3/5 relative h-[400px]">
            {/* <img
              alt="recpad"
              className="h-full w-full object-cover object-bottom absolute inset-0 "
              src={recpad}
            /> */}
            <Carousel
              className="rounded-xl h-full w-full  "
              // indicators
              loop
              autoplay
              prevArrow={() => ""}
              nextArrow={() => ""}
            >
              <img
                src={ubiarea}
                alt="ubi_parking_area"
                className="h-full w-full object-cover "
              />
              <img
                src={ubi2}
                alt="ubi_atrium"
                className="h-full w-full object-cover"
              />
              <img
                src={recpad}
                alt="auditorium"
                className="h-full w-full object-cover "
              />
            </Carousel>
            <div className="absolute inset-0 bg-black opacity-50 rounded-xl" ></div>
            <div className="absolute inset-0 p-8 flex flex-col justify-between">
              <Typography variant="h4" color="white" className="mb-2 w-[70%] ">
                30TH PORTUGUESE  CONFERENCE ON PATTERN RECOGNITION - RECPAD 2024
              </Typography>
              <Typography color="white" className="mb-2 w-1/2 ">
                <Link to="/location" >
                  UNIVERSIDADE DA BEIRA INTERIOR, COVILHÃ, PORTUGAL
                </Link>
              </Typography>
            </div>
          </Card>


        </motion.section>
        {/* \INVITED SPEAKER SECTION */}
        <motion.section className="w-full container mx-auto py-12 lg:px-14 z-10"
          initial={FADE_BOTTOM.initial}
          whileInView={FADE_BOTTOM.final}
          transition={{
            duration: 0.4,
            delay: 0.2
          }}
          viewport={{ once: true }}
        >

          <motion.div className="w-full relative flex flex-col lg:flex-row items-center gap-4"  >


            <motion.div className="rounded-none w-full flex flex-col justify-center relative z-10"
              initial={FADE_BOTTOM.initial}
              whileInView={FADE_BOTTOM.final}
              transition={{
                duration: 0.3,
                delay: 0.2
              }}
              viewport={{ once: true }}
            >
              <div className="py-12 px-8 w-full flex justify-center items-center" >

                <div>
                  <img
                    alt="invited"
                    className="max-h-[400px] object-center rounded"
                    src={guest}
                  />
                </div>

              </div>

            </motion.div>

            <motion.div className="w-full flex justify-center"
              initial={FADE_BOTTOM.initial}
              whileInView={FADE_BOTTOM.final}
              transition={{
                duration: 0.4,
                delay: 0.4
              }}
              viewport={{ once: true }}
            >
              <div className="flex flex-col justify-center px-8 lg:px-0 h-full">
                <Typography variant="h2" color="blue-gray" className="mb-2">
                  Invited Speaker
                </Typography>

                <Typography color="blue-gray" className="mb-2">
                  Ruben Vera Rodríguez - Professor at the Autonomous University of Madrid and member of the BiDA Lab
                </Typography>
                <Typography color="blue-gray" className="mb-2 underline text-ubi-500 font-semibold">
                  {/* <a href="https://scholar.google.com/citations?user=KYMQ0tsAAAAJ&hl" target="_blank" >https://scholar.google.com/citations?user=KYMQ0tsAAAAJ&hl</a> */}
                  <a href="https://www.researchgate.net/profile/Ruben-Vera-Rodriguez" target="_blank" >https://www.researchgate.net/profile/Ruben-Vera-Rodriguez</a>
                </Typography>
              </div>
            </motion.div>
          </motion.div>

          <motion.div className="flex flex-col justify-center  w-full h-full p-8"
            initial={FADE_BOTTOM.initial}
            whileInView={FADE_BOTTOM.final}
            transition={{
              duration: 0.4,
              delay: 0.2
            }}
            viewport={{ once: true }}
          >
            <Typography variant="h3" color="blue-gray" className="mb-2">
              Talk
            </Typography>
            <Typography color="gray" className="font-normal mt-2">
              Advances in Behavioral Mobile Biometrics and in Face Recognition through AI Generated Images
            </Typography>

            <Typography variant="h3" color="blue-gray" className="mb-2 mt-8">
              Biography
            </Typography>
            <Typography color="gray" className="font-normal mt-2">
              Ruben Vera Rodríguez is a renowned computer scientist and pioneer in the fields of behavioral mobile biometrics and AI-generated facial recognition. He is currently an Associate Professor at the Autonomous University of Madrid and member of the BiDA Lab, focused on forensics and biometrics for security and human behavior analysis. He is author of more than 150 scientific articles published in international journals and conferences. He has served as Program Chair for some international conferences such as: IEEE ICCST 2017, CIARP 2018, ICBEA 2019 and AVSS 2022. He has also organized several workshops and challenges in top conferences such as WAMWB (MobileHCI 2023), KVC (BigData 2023), MobileB2C (IJCB 2022) and SVC-onGoing (ICDAR 2021). Ruben has received a Medal in the Young Researcher Awards 2022 by the Spanish Royal Academy of Engineering among other awards, and he is member of ELLIS Society since 2023.
            </Typography>
          </motion.div>

        </motion.section >

        <section className="w-full container mx-auto  px-8" >

          <Typography variant="h3" color="blue-gray" className="mb-2">
            Conference Location
          </Typography>
          <Typography color="gray" className="font-normal mt-2">
            The event will take place at <strong><a className="underline" target='_blank' href="https://maps.app.goo.gl/b4J1VHxGusmSbX1V6">Universidade da Beira Interior - Faculdade de Ciências da Saúde, Av. Infante D. Henrique, 6200-506 Covilhã</a></strong>
          </Typography>
          <MapContainer />

          <div className="mt-10">
            <Typography variant="h3" color="blue-gray" className="mb-2">
              Convenient parking and access
            </Typography>
            <Typography color="gray" className="font-normal mt-2">
              The <strong>Faculdade de Ciências da Saúde</strong> offers ample parking, a convenient location, and easy access to a variety of dining options.
            </Typography>
          </div>
          <div className="w-full flex justify-center mt-12" >
            <img
              src={ubiarea}
              alt="ubi_parking_area"
              className="h-full w-full max-w-[600px] object-cover"
            />
          </div>


        </section>

        <motion.section className="w-full container mx-auto py-12 px-8 lg:px-14 z-10 mt-10"
          initial={FADE_BOTTOM.initial}
          whileInView={FADE_BOTTOM.final}
          transition={{
            duration: 0.4,
            delay: 0.2
          }}
          viewport={{ once: true }}
        >
          <Typography variant="h3" color="blue-gray" className="mb-2">
            Partner Hotel Accommodation
          </Typography>
          <Typography color="gray" className="font-normal mt-2">
            We are pleased to announce that <strong><a className="underline" target='_blank' href="https://www.sporthotel.pt/en/">Sport Hotel Gym + Spa</a></strong> is the official accommodation partner for our conference.
          </Typography>


          <motion.div className="w-full relative flex flex-col lg:flex-row items-center gap-4 mt-8"  >


            <motion.div className="w-full flex justify-center"
              initial={FADE_BOTTOM.initial}
              whileInView={FADE_BOTTOM.final}
              transition={{
                duration: 0.4,
                delay: 0.4
              }}
              viewport={{ once: true }}
            >
              <div className="flex flex-col justify-center  h-full">
                <Typography variant="h4" color="blue-gray" className="mb-2">
                  Exclusive Offer for Conference Attendees:
                </Typography>

                <Typography color="blue-gray" className="mb-2">
                  Sport Hotel is offering a 10% discount on room reservations for all conference participants. To take advantage of this offer, you must make your reservation directly with the hotel through email or telephone and mention that you are participating in the RECPAD conference.
                </Typography>
                {/* <Typography color="blue-gray" className="mb-2 underline text-ubi-500 font-semibold">
                  <a href="https://www.researchgate.net/profile/Ruben-Vera-Rodriguez" target="_blank" >https://www.researchgate.net/profile/Ruben-Vera-Rodriguez</a>
                </Typography> */}

                <Typography color="gray" className="font-normal mt-2">
                  Email: <strong><a className="underline" target='_blank' href="mailto:centraldereservas@naturaimbhotels.com"> centraldereservas@naturaimbhotels.com</a></strong>
                </Typography>
                <Typography color="gray" className="font-normal mt-2">
                  Telephone:
                  <a
                    // href="tel:+351275330406"
                    className="underline cursor-pointer"
                    onClick={() => handlePhoneNumberClick('+351 275 330 406')}
                  >
                    +351 275 330 406
                  </a>
                </Typography>

                <Typography color="blue-gray" className="mb-2">
                  For more information about the hotel and its facilities, please visit <strong><a className="underline" target='_blank' href="https://www.sporthotel.pt/en/">Sport Hotel's official website.</a></strong>
                </Typography>

              </div>
            </motion.div>

            <motion.div className="rounded-none w-full flex flex-col justify-center relative z-10"
              initial={FADE_BOTTOM.initial}
              whileInView={FADE_BOTTOM.final}
              transition={{
                duration: 0.3,
                delay: 0.2
              }}
              viewport={{ once: true }}
            >
              <div className="py-12 px-8 w-full flex justify-center items-center" >

                <div>
                  <img
                    alt="hotel"
                    className="max-h-[400px] object-center rounded"
                    src={hotel}
                  />
                </div>

              </div>

            </motion.div>

          </motion.div>



        </motion.section >
        <Footer />

      </div>
    </>
  );
}
